//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { contList } from "@/api/contract/contract";
export default {
	data() {
		return {
			contCateCode: this.$route.params.contCateCode,
			contTypeCode: this.$route.params.contTypeCode,
			gobackName: this.$route.params.gobackName,
			contractList: 10,
			refreshing: false,
			loading: false,
			text: 'List',
			checkbox: '',
			tableData: [],
			condition: {
				contName: '',
				page: 1,
				limit: 10,
			},
			scroll: 0,
		}
	},
	created() {
		this.getData();
	},
	activated() {
		this.$refs.container.scrollTop = this.scroll
	},
	methods: {
		// 查找
		searchEvent() {
			this.getData();
		},
		clearFilter() {
			this.condition.contName = '';
			this.condition.page = 1;
			this.getData();
		},
		//下拉刷新
		loadingData() {
			var data = {
				'page': this.condition.page,
				'limit': this.condition.limit,
				'contName': this.condition.contName,
				'pageType': 'lookFor',
				'contCateCode': this.contCateCode,
				'contTypeCode': this.contTypeCode,
			};
			contList(data).then(response => {
				for (var i = 0; i < response.data.length; i++) {
					this.tableData.push(response.data[i])
				}
			});
		},
		getData() {
			var data = {
				'page': this.condition.page,
				'limit': this.condition.limit,
				'contName': this.condition.contName,
				'pageType': 'lookFor',
				'contCateCode': this.contCateCode,
				'contTypeCode': this.contTypeCode,
			};
			contList(data).then(response => {
				this.tableData = response.data;
			});
		},
		returnList() {
			if (this.gobackName == "合同总览") {
				this.$router.push({
					name: '合同总览'
				});
			} else {
				this.$router.push({
					path: '/'
				})
			}
		},
		refresh() {
			this.refreshing = true
			this.$refs.container.scrollTop = 0
			setTimeout(() => {
				this.refreshing = false
				// this.text = this.text === 'List' ? 'Menu' : 'List'
				this.num = 10
				this.contractList = 10
			}, 2000)
		},
		load() {
			this.loading = true;
			setTimeout(() => {
				this.condition.page++;
				this.loading = false;
				this.loadingData();
			}, 1000)
		}, // 全部
		serchAll(event) {
			var Button = document.getElementsByClassName('ButtonTran')
			if (Button.length != 0) {
				Button[0].className = 'serchButton'
			}
			event.srcElement.className = 'ButtonTran'
		}, // 待审批
		beReim(event) {
			var Button = document.getElementsByClassName('ButtonTran')
			if (Button.length != 0) {
				Button[0].className = 'serchButton'
			}
			event.srcElement.className = 'ButtonTran'
		}, // 审批中
		inReim(event) {
			var Button = document.getElementsByClassName('ButtonTran')
			if (Button.length != 0) {
				Button[0].className = 'serchButton'
			}
			event.srcElement.className = 'ButtonTran'
		}, // 审批后
		afterReim(event) {
			var Button = document.getElementsByClassName('ButtonTran')
			if (Button.length != 0) {
				Button[0].className = 'serchButton'
			}
			event.srcElement.className = 'ButtonTran'
		},
		detailClick(id, contTypeCode) {
			let containerScrollTop = this.$refs.container.scrollTop
			this.scroll = containerScrollTop
			if (contTypeCode == 'software_sale' || contTypeCode == 'technical_service') {
				this.$router.push({
					path: '/contract/technicalSoftwareDetail',
					query: {
						cid: id,
						contCateCode: this.contCateCode,
						contTypeCode: this.contTypeCode,
						gobackName: this.gobackName
					}
				});
			}
			if (contTypeCode == 'human_day_service') {
				this.$router.push({
					path: '/contract/humanDayServiceDetail',
					query: {
						cid: id,
						contCateCode: this.contCateCode,
						contTypeCode: this.contTypeCode,
						gobackName: this.gobackName
					}
				});
			}
			if (contTypeCode == 'human_day_total') {
				this.$router.push({
					path: '/contract/humanDayTotalDetail',
					query: {
						cid: id,
						contCateCode: this.contCateCode,
						contTypeCode: this.contTypeCode,
						gobackName: this.gobackName
					}
				});
			}
			if (contTypeCode == 'purchase_contract') {
				this.$router.push({
					path: '/contract/purchaseDetail',
					query: {
						cid: id,
						contCateCode: this.contCateCode,
						contTypeCode: this.contTypeCode,
						gobackName: this.gobackName
					}
				});
			}
			if (contTypeCode == 'ctrip_businessTravel') {
				this.$router.push({
					path: '/contract/ctripDetail',
					query: {
						cid: id,
						contCateCode: this.contCateCode,
						contTypeCode: this.contTypeCode,
						gobackName: this.gobackName
					}
				});
			}
			if (contTypeCode == 'humanDay_outsourcing') {
				this.$router.push({
					path: '/contract/humanDayoutDetail',
					query: {
						cid: id,
						contCateCode: this.contCateCode,
						contTypeCode: this.contTypeCode,
						gobackName: this.gobackName
					}
				});
			}
			if (contTypeCode == 'other_payment_contract') {
				this.$router.push({
					path: '/contract/otherPaymentContractDetail',
					query: {
						cid: id,
						contCateCode: this.contCateCode,
						contTypeCode: this.contTypeCode,
						gobackName: this.gobackName
					}
				});
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/view/contract/contractList.vue